import { useMemo } from 'react';
import { z } from 'zod';
import type {
  HydrogenCapacityCategory,
  HydrogenNetworkPoint,
} from 'src/apis/hydrogen-fcfs/types';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

export const getHydrogenNetworkPointPageParamsSchema = (
  networkPoint: HydrogenNetworkPoint
) => {
  return z.object({
    capacityCategory: z
      .custom<HydrogenCapacityCategory>()
      .default(networkPoint.capacityCategories[0]),
  });
};

export function useHydrogenNetworkPointPageParams(
  networkPoint: HydrogenNetworkPoint
) {
  const schema = useMemo(
    () => getHydrogenNetworkPointPageParamsSchema(networkPoint),
    [networkPoint]
  );
  return usePageParamsFromSchema(schema);
}

export type HydrogenNetworkPointPageParams = ReturnType<
  typeof useHydrogenNetworkPointPageParams
>;
